import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../../../../boot";

// Get products
export const getProduct = createAsyncThunk(
  "client/get-product-list",
  async (data, { rejectWithValue }) => {
    const token = localStorage.getItem("authToken");

    try {
      const response = await axios.post(
        `${baseUrl}vancouverapis/admin/product/api/v1/get-product-list`,
        data,
        {
          headers: {
            "auth-token": token,
            // "Content-Type": "application/json",
          },
        }
      );
      // console.log("product response", response);
      return response.data; // ✅ Return only the data
    } catch (error) {
      console.error("Error fetching products:", error);

      // ✅ Handle errors properly
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch products"
      );
    }
  }
);
